import React, { useEffect, useMemo, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../../../../../_metronic/_partials/controls';
import { currencyFormatter } from '../../../../../../../../../_metronic/_helpers/UtilityHelpers'
import * as actions from '../../../../../../_redux/donation/donationAction';
import * as uiHelpers from '../DonationPaymentHelpers';
import { toast } from 'react-toastify'
import { Link } from "react-router-dom";


import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage, toastOption,
} from '../../../../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../../../../_metronic/_partials/controls';
import { useDonationUIContext } from '../DonationPaymentUIContext';

export const DonationTable = () => {

    const donationUIContext = useDonationUIContext();
    const donationUIProps = useMemo(() => {
        return {
            queryParams: donationUIContext.queryParams,
            setQueryParams: donationUIContext.setQueryParams,
            openDetailDonationPage: donationUIContext.openDetailDonationPage,
            filterType: donationUIContext.filterType,
            openDialogVoid: donationUIContext.openDialogVoid,
            addDonationToReconcile: donationUIContext.addDonationToReconcile,
            removeDonationFromReconcile: donationUIContext.removeDonationFromReconcile,
            addDonationToReconcileAll: donationUIContext.addDonationToReconcileAll,
            removeDonationFromReconcileAll: donationUIContext.removeDonationFromReconcileAll,
            bankAccount: donationUIContext.bankAccount
        };
    }, [donationUIContext]);

    // Getting curret state of donation list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.donations }),
        shallowEqual,
    );

    const { user } = useSelector(
        (state) => ({ user: state.auth.user }),
        shallowEqual,
    );
    // const { totalCount, entities, listLoading, donation_item_array } = currentState;
    const { totalCount, entities, listLoading, error } = currentState;
    if (error) {
        toast.error(error, toastOption);

    }
    let amountArray = []

    const [showBankStatement, setShowBankStatement] = useState({})
    const [showChannelTrx, setShowChannelTrx] = useState({})

    const dispatch = useDispatch();
    useEffect(() => {
        //Force queryParams Jika url donation/type diberikan value
        if (donationUIProps.filterType !== undefined) {
            donationUIProps.queryParams.filter.channel_type = donationUIProps.filterType.toUpperCase();
        }

        // Untuk menampilkan field bank message khusus tipe bank
        if (donationUIProps.queryParams && donationUIProps.queryParams.filter.channel_type === 'BANK') {
            setShowBankStatement({
                dataField: 'bank_message',
                text: 'Pesan Bank',
            })
            setShowChannelTrx({})
        } else if (donationUIProps.queryParams && donationUIProps.queryParams.filter.channel_type === 'ECHANNEL') {
            setShowChannelTrx({
                dataField: 'channel_trx_id',
                text: 'Invoice ID',
            })
            setShowBankStatement({})
        } else {
            setShowBankStatement({})
            setShowChannelTrx({})
        }

        //Requset ke Donation Action
        dispatch(actions.fetchDonationPayments(donationUIProps.queryParams));


        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [donationUIProps.queryParams, donationUIProps.filterType, dispatch]);

    // total donation 
    // if (donation_item_array !== undefined) {
    //     donation_item_array.forEach(amount => {
    //         if (amount !== null) {
    //             amountArray.push(Number(amount.amount))
    //         }
    //     });
    // }
    // const reducer = (accumulator, currentValue) => accumulator + currentValue;
    // let totalAmount;
    // if (amountArray.length !== 0) {
    //     totalAmount = currencyFormatter(amountArray.reduce(reducer))
    // }
    // Table columns
    const selectRow = {
        mode: 'checkbox',
        clickToSelect: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            if (isSelect) {
                donationUIProps.addDonationToReconcile(row)
            } else {
                donationUIProps.removeDonationFromReconcile(row.uuid)
            }
        },
        onSelectAll: (isSelect, rows, e) => {
            if (isSelect) {
                // rows.forEach((row) => {
                //     donationUIProps.addDonationToReconcile(row)

                // })
                // for (const row of rows) {
                //     donationUIProps.addDonationToReconcile(row)
                // }
                donationUIProps.addDonationToReconcileAll(rows)

            } else {
                // for (const index in rows) {
                //     let row = rows[index]
                //     donationUIProps.removeDonationFromReconcile(row.uuid)
                // }
                // for (const row of rows) {

                // }
                donationUIProps.removeDonationFromReconcileAll(rows)

            }

        }
    };
    const columns = [
        {
            dataField: 'donation.donation_hid',
            text: 'Donation HID',
        },
        {
            dataField: 'donation.trx_date',
            text: 'Tanggal Donasi',
            formatter: columnFormatters.DateColumnFormatter,
        },
        {
            dataField: 'payment_method.name',
            text: 'Cara Pembayaran',
        },
        {
            dataField: 'amount',
            text: 'Jumlah',
            headerClasses: 'text-right',
            classes: 'text-right',
            formatter: function (val) {
                return currencyFormatter(val)
            },
        },
        // {
        //     dataField: 'donation.donor.name',
        //     text: 'Nama Donatur',
        // },
        //BUAT TAMPILIN FIELD DESKRIPSI BANK
        {
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openDetailDonationPage: donationUIProps.openDetailDonationPage,
                openDialogVoid: donationUIProps.openDialogVoid,
                role: user.role,
                Link: Link,
                addDonationToReconcile: donationUIProps.addDonationToReconcile,
            },
        }

    ];
    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: donationUIProps.queryParams.pageSize,
        page: donationUIProps.queryParams.pageNumber,
    };
    return (

        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                // defaultSorted={uiHelpers.defaultSorted}
                                onTableChange={getHandlerTableChange(
                                    donationUIProps.setQueryParams,
                                )}
                                pageNumber={10}
                                // selectRow={getSelectRow({
                                //   entities,
                                //   ids: productsUIProps.ids,
                                //   setIds: productsUIProps.setIds,
                                // })}
                                {...paginationTableProps}
                                selectRow={selectRow}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
            {/* <CardHeader title="Total Donasi">
                <h1>{totalAmount === [] ? "Tidak Ada Donasi" : totalAmount}</h1>
            </CardHeader> */}
        </>
    );
};
